import type { FC } from 'react';

import styles from './TextSkeleton.module.scss';

interface TextSkeletonProps {
  width?: string;
  lines?: number;
  testId?: string;
}

const TextSkeleton: FC<TextSkeletonProps> = ({ width = '100%', lines = 1, testId = 'text-skeleton' }) => {
  if (lines <= 1) {
    return <span className={styles.Skeleton} style={{ width }} data-testid={testId} aria-hidden="true" />;
  }

  return (
    <span className={styles.Stack} data-testid={testId} aria-hidden="true">
      {Array.from({ length: lines }, (_, index) => (
        <span
          key={index}
          className={styles.Skeleton}
          data-testid="text-skeleton-line"
          style={{ width: index === lines - 1 ? '55%' : width }}
        />
      ))}
    </span>
  );
};

export default TextSkeleton;
